import { render } from "./login_jvta.vue?vue&type=template&id=5a9948af"
import script from "./login_jvta.vue?vue&type=script&lang=js"
export * from "./login_jvta.vue?vue&type=script&lang=js"

import "./login_jvta.vue?vue&type=style&index=0&id=5a9948af&lang=css"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__